<template>
  <v-container class="form-container rounded-lg">
    <h1>Edit department</h1>
    <EditForm :fields="fields" name="departments" />
  </v-container>
</template>

<script>
import { markRaw } from "vue";
import TextField from "@/Admin/components/form/TextField.vue";

import { ruleSetGen } from "@/Admin/helpers/rules";
import EditForm from "@/Admin/components/EditForm.vue";
import config from "@/helpers/api";
export default {
  name: "DepartmentEditView",
  components: { EditForm },
  data() {
    return {
      fields: {
        name: {
          component: markRaw(TextField),
          data: {
            label: "Name",
            placeholder: "Enter department name",
            name: "name",
            rules: ruleSetGen.text("Enter correct key word name", true, 3),
          },
        },
      },
    };
  },
  async created() {
    await fetch(`${config.baseURL}/departments/${this.$route.params.id}`, {
      method: "GET",
      headers: config.headers,
    })
      .then((response) => response.json())
      .then((response) => {
        for (const key in this.fields) {
          this.fields[key].data.value = response.data[key];
        }
      });
  },
};
</script>

<style scoped>
.form-container {
  width: 1000px;
  margin: auto;
  background-color: white;
  padding: 10px;
}
</style>
